import type { FaireProductEntity } from "../../entity_types/product";

export const p_vrp2jmxbp9: FaireProductEntity = {
  token: "p_vrp2jmxbp9",
  type: "product",
  name: "Mini Travel Sized Anointing Oil",
  brandToken: "b_996syxfhau",
  brandName: "Gospel Gear Co",
  imageUrl:
    "https://cdn.faire.com/fastly/d3b738e7c56953ce23226b7bedaa7cd63cad5ef267753c387bb3a6a02c3c739c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33f9e8570b44d561aa86b048d838bfbb9ca98636fb011aed76c06cc35d0332e7.jpeg",
    "https://cdn.faire.com/fastly/af64f7cc1d40f0b2e5a3eb166220a4ac194554d1e0fd13e6ad0013defacd4c52.jpeg",
    "https://cdn.faire.com/fastly/8012276e73f2300405dc90ec2c3c899db8a28e0131d51b7cf5fb6430217b27b8.jpeg",
  ],
  priceDollars: 1,
  description:
    "Get ready to fall in love with our new mini travel sized anointing oils! These travel sized mini oils are perfect to give as gifts, take to church events, or keep on hand for your daily prayers! They are the convenient way to ensure you are prepared whenever a prayer, anointing, or deliverance may be taking place!\n\nThey are a frankincense and myrrh anointing oil that is olive based. Each vial is 3 mls and made of glass! Stock up in bulk or grab just one!\n\nThis oil does contain a scent being composed of olive, frankincense, and myrrh oils!\n",
  tags: [],
  msrpDollars: 2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:52.766Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
